<template>
  <div :class="{'jom-fig':true,'rc_mode':layout == 'rc'}" :id="data.id">
    <div class="fig">
      <img v-for="item in this.data.graphics" v-lazy="setImgSrc(item)" :data-width="width(item)" alt="fig"
           v-bind:style="{ 'width':  '30px', 'max-width': '90%'}" @click="showBigPic(item)"/>
    </div>
    <div class="subcaption theme-color" v-if="this.data.subcaption!=''">
      <p v-bind:style="{ 'width': width + 'px' }" class="theme-font">
                <span v-for="item in this.data.subcaption" v-bind:key="item.index">
                    <component :is="'jo' + item2.name" v-for="item2 in item.label" v-bind:key="item2.index"
                               v-bind:data="item2.data"></component>
                    <component :is="'jo' + item2.name" v-for="item2 in item.title" v-bind:key="item2.index"
                               v-bind:data="item2.data"></component>
                </span>
      </p>
    </div>

    <div class="main-title " v-if="this.mainCaption.length > 0&& this.mainCaption[0].title.length > 0">
      <p class="theme-font">
                <span v-for="(captionItem,index) in mainCaption" :key="captionItem.label+index"
                      :class="index!=0 ? 'blank-space':''">
                  <!--不在:key前面加一个独特的字符，会导致报错但不影响渲染，但console报错总是不好，所以这里加上两个前缀-->
                  <component :is="'jo' + item.name" v-for="(item,index) in captionItem.label" v-bind:key="'QAQ'+index"
                             v-bind:data="item.data"></component>{{layout=='rc' ? '&nbsp;' :''}}&nbsp;
                  <component :is="'jo' + item.name" v-for="(item,index) in captionItem.title" v-bind:key="'OvO'+index"
                             v-bind:data="item.data"></component>
                </span>
      </p>
    </div>

    <div class="sub-title" v-if="this.subCaption.length > 0">
      <p class="theme-font">
        <span v-for="(captionItem,index) in subCaption" :key="captionItem.label+index">
            <component :is="'jo' + item.name" v-for="(item,index) in captionItem.label" v-bind:key="'QAQ'+index"
                       v-bind:data="item.data"></component>{{layout=='rc' ? '&nbsp;' :''}}
          <component :is="'jo' + item.name" v-for="(item,index) in captionItem.title" v-bind:key="index"
                     v-bind:data="item.data"></component>
          </span>
      </p>
    </div>

    <div v-if="this.data.note && this.data.note.length > 0">
      <div class="table-note" v-for="(noteItem,index) in this.data.note" :key="'note'+index">
        <!--<span v-if="noteItem.data[0].name && noteItem.data[0].name != 'vocab'">{{noteItem.lang == 'zh' ? '注：' : 'NOTE:'}}</span>-->
        <p v-for="(item,index) in noteItem.data">
          <component :is="'jo' + item.name" v-bind:key="index" v-bind:data="item.data"></component>
          <span v-if="index != noteItem.data.length-1 && !hasColon(item)">{{noteItem.lang == 'zh' ? '；' : '; '}}</span>
        </p>
      </div>
    </div>
    <el-dialog :show-close="false" width="100%" top="0" custom-class="jom-bigPicDialog" :visible.sync="isShowBigPic"
               :modal="false" @open="closePosition" @close="initPosition">
      <img ref="bigPic" :src="this.currentGraphic.big" width="90%" alt="fig">
    </el-dialog>
  </div>
</template>

<script>
  import joinlineformula from '../formula/inlineformula.vue'
  import joinlinegraphic from './inlinegraphic.vue'

  export default {
    components: {
      joinlineformula,
      joinlinegraphic
    },
    props: [
      'data'
    ],
    data() {
      return {
        subCaption: [],
        mainCaption: [],
        picHeight: 'inherit',
        isShowBigPic: false,
        scrollTop: 0,
        bigImageTop: 0,
        bigImageLeft: 0,
        bigImageWidth: 0,
        bigImageHeight: 0,
        currentGraphic: this.data.graphics[0]
      }
    },
    created() {
        if (this.data.caption && this.data.caption.length > 0) {
          this.mainCaption.push(this.data.caption[0]);
          if (this.data.caption.length > 1) {
            this.subCaption.push(this.data.caption[1]);
          }
        }
      /*for (let item of this.data.caption) {
        if (item.lang!==this.ARTICLE.defaultlang) {
          this.subCaption.push(item);
        } else {
          this.mainCaption.push(item);
        }
      }*/
    },
    mounted() {
      let _this = this
      $(window).on('resize', function () {
        $('.el-dialog__body').css({'display': 'block'})
        _this.$nextTick(() => {
          $('.el-dialog__body').css({'display': 'flex'})
          if ($(_this.$refs.bigPic).position() !== undefined) {
            _this.closePosition()
          }
        })
      })
    },
    watch: {
      isShowBigPic: function (val) {
        if (val) {
          this.scrollTop = $(window).scrollTop()
          $("body,html").addClass('jom-dialog-pop-body');
        } else {
          $("body,html").removeClass('jom-dialog-pop-body')
          $(window).scrollTop(this.scrollTop);
        }
      }
    },
    methods: {
      setImgSrc (item){
        if (item.big && item.big !== ''){
          return item.big;
        }
        if (item.small && item.small !== ''){
          return item.small;
        }
        if (item.print && item.print !== ''){
          return item.print;
        }
      },
      width(graphic) {
        /*毫米转化为像素*/
        let width = graphic.width * this.GLOBAL.deviceDPI.x / 25.4;
        return width * 1.6;
      },
      showBigPic(item) {
        if (this.layout != 'rc'){
          this.isShowBigPic = true;
          this.currentGraphic = item
        }
      },
      closePosition() {
        let _this = this
        _this.$nextTick(() => {
          $(_this.$refs.bigPic).css({'top': ($(window).height() - $(_this.$refs.bigPic).height()) / 2});
          $('.el-dialog__body').on('click', function () {
            _this.isShowBigPic = false
          })
          $(_this.$refs.bigPic).on('click', function (e) {
            e.stopPropagation()
          })
          this.zoomPic();
          if ($(_this.$refs.bigPic).position() !== undefined) {
            _this.bigImageTop = $(_this.$refs.bigPic).position().top
            _this.bigImageLeft = $(_this.$refs.bigPic).position().left
            let left = $(_this.$refs.bigPic).position().left + $(_this.$refs.bigPic).width()
            $('.jom-bigPicDialog .el-dialog__headerbtn').css({
              'top': (_this.bigImageTop + 5) + 'px',
              'left': (left - 31) + 'px'
            })
          }
          _this.bigImageWidth = $(_this.$refs.bigPic).width();
          _this.bigImageHeight = $(_this.$refs.bigPic).height();
        })
      },
      initPosition() {
        $(this.$refs.bigPic).css({
          'top': this.bigImageTop + 'px',
          'left': this.bigImageLeft + 'px',
          'width': this.bigImageWidth + 'px',
          'height': this.bigImageHeight + 'px'
        })
      },
      zoomPic: function () {
        var _this = this;
        var startX, endX, scale, x1, x2, y1, y2, imgLeft, imgTop, imgWidth, imgHeight,
          one = false,
          $touch = $(this.$refs.bigPic),
          originalWidth = $touch.width(),
          originalHeight = $touch.height(),
          baseScale = parseFloat(originalWidth / originalHeight);

        function siteData(name) {
          imgLeft = parseInt(name.css('left'));
          imgTop = parseInt(name.css('top'));
          imgWidth = name.width();
          imgHeight = name.height();
        }

        $(_this.$refs.bigPic).on('touchstart touchmove touchend', function (event) {
          var $me = $(_this.$refs.bigPic),
            touch1 = event.originalEvent.targetTouches[0],  // 第一根手指touch事件
            touch2 = event.originalEvent.targetTouches[1],  // 第二根手指touch事件
            fingers = event.originalEvent.touches.length;   // 屏幕上手指数量
          //手指放到屏幕上的时候，还没有进行其他操作
          if (event.type == 'touchstart') {
            if (fingers == 2) {
              // 缩放图片的时候X坐标起始值
              startX = Math.abs(touch1.pageX - touch2.pageX);
              one = false;
            }
            else if (fingers == 1) {
              x1 = touch1.pageX;
              y1 = touch1.pageY;
              one = true;
            }
            siteData($me);
          }
          //手指在屏幕上滑动
          else if (event.type == 'touchmove') {
            if (fingers == 2) {
              // 缩放图片的时候X坐标滑动变化值
              endX = Math.abs(touch1.pageX - touch2.pageX);
              scale = endX - startX;
              $me.css({
                'width': originalWidth + scale,
                'height': (originalWidth + scale) / baseScale,
                'left': imgLeft,
                'top': imgTop
              });

            } else if (fingers == 1) {
              x2 = touch1.pageX;
              y2 = touch1.pageY;
              if (one) {
                $me.css({
                  'left': imgLeft + (x2 - x1),
                  'top': imgTop + (y2 - y1)
                });
              }
            }
          }
          //手指移开屏幕
          else if (event.type == 'touchend') {
            // 手指移开后保存图片的宽
            originalWidth = $touch.width()
            siteData($me);
          }
          event.preventDefault();
          event.stopPropagation();
        });
      },
      hasColon(item){
        let hasColon = false;
        if (item.name === 'p'){
          hasColon = this.hasColon(item.data[item.data.length-1]);
        } else if (item.name==='text'){
          if(item.data.lastIndexOf(';')===item.data.length-1 ||
            item.data.lastIndexOf('；')===item.data.length-1){
            return true
          }
        }
        return hasColon;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .jom-fig {
    box-sizing: border-box;
    width: 100%;
    margin: 1.5rem 0px;
    /*padding: 20px;*/
    background: #ffffff;
    text-align: center;
    & > img {
      margin-bottom: 10px;
      &:hover {
        cursor: pointer;
      }
    }
    .jo-anchor {
      display: block;
      visibility: hidden;
    }
    .subcaption {
      display: flex;
      justify-content: center;
      p {
        display: flex;
        justify-content: space-around;
        width: 90%;
        > span {
          padding: 0 10px;
          flex: 1;
        }
      }
    }
    .subcaption p, .main-title p, .sub-title p {
      margin-top: 10px;
      font-size: 1.2rem;
      line-height: 18px;
      text-align: center;
      color: #00a2af;
      text-indent: 0;
      font-weight: bold;
    }

    .main-title .sup, .sub-title .sup {
      display: inline-block;
    }

    .table-note {
      text-align: left;
      span {
        font-weight: bold;
        /*font-size: 1.2rem;*/
      }
      p {
        display: inline;
        margin: 0;
        /*font-size: 1.2rem;*/
        line-height: 18px;
        text-indent: 0;
      }
    }
    span.blank-space {
      margin-left: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/componentsMobile/maincontent/body/fig/fig.vue